import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import type { WizardState, WizardStep } from '../api';
import { WizardShell } from '../wizard/WizardShell';
import { StepSelf } from '../wizard/StepSelf';
import { StepParties } from '../wizard/StepParties';
import { StepAccounts } from '../wizard/StepAccounts';
import { StepOpeningBalances } from '../wizard/StepOpeningBalances';
import { StepDone } from '../wizard/StepDone';

export function WizardPage({ wizard }: { wizard: WizardState }) {
  const [activeStep, setActiveStep] = useState<WizardStep | null>(null);
  const nav = useNavigate();

  useEffect(() => {
    setActiveStep((prev) => prev ?? wizard.currentStep);
  }, [wizard]);

  const step = activeStep ?? wizard.currentStep;

  return (
    <WizardShell
      wizard={wizard}
      activeStep={step}
      onStepSelect={setActiveStep}
      extra={
        <div className="mt-6 space-y-2 border-t border-border pt-4 text-caption text-ink-muted">
          {wizard.completed && (
            <button
              type="button"
              className="text-brand underline hover:text-brand-dark"
              onClick={() => nav('/batches')}
            >
              Go to batches →
            </button>
          )}
          <div>
            <Link to="/batches" className="hover:text-ink">
              Skip for now
            </Link>
          </div>
        </div>
      }
    >
      {step === 'self' && <StepSelf wizard={wizard} />}
      {step === 'uplines' && (
        <StepParties
          role="upline"
          title="Step 2 — Upline parties"
          description="Parties you receive weekly P&L sheets from. Usually just SRB."
          hint="Exact casing is preserved; case-insensitive matching is used internally."
          minCount={1}
        />
      )}
      {step === 'clients' && (
        <StepParties
          role="client"
          title="Step 3 — Client parties (POCs)"
          description="Parties who sub-lease accounts from you."
          hint="e.g. Gori Bhaiya, Vikky Bhai, Victor Bhai, Anshu."
          minCount={1}
        />
      )}
      {step === 'accounts' && <StepAccounts />}
      {step === 'opening_balances' && <StepOpeningBalances />}
      {step === 'done' && <StepDone wizard={wizard} />}
    </WizardShell>
  );
}
